import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { UserIcon } from "@heroicons/react/24/outline";
import { FaDownload, FaBars, FaTimes, FaUser } from "react-icons/fa";
import { supabase } from "./superbase/superbaseClient";

import "./Styles/Navbar.css";
import Logo from "./images/LOGO_AGNIGBAN_GNA Trs Noir2 (2).png";
import AppStore from "./images/Nappe mariage - Passion Décor.jpeg";
import PlayStore from "./images/Google Play Badge Logo - PNG Logo Vector Brand Downloads (SVG, EPS).jpeg";
import PlayButton from "./images/Play_Button_free_icons_designed_by_Freepik-removebg-preview.png";
import CodeQR from "./images/Custom_QR_Code_Car_Decal_Personalized_Website_or_Social_Media_Business-removebg-preview.png";
import { useMediaQuery } from "react-responsive";

export default function Navbar() {
  // --------------------RESPONSIVE-----------------------------
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  // --------------------------------------------------------------------

  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [userFirstName, setUserFirstName] = useState("");

  useEffect(() => {
    // Vérifier si un utilisateur est connecté
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session?.user) {
        setUser(session.user);
        // Récupérer le prénom depuis les metadata
        if (session.user.user_metadata?.first_name) {
          setUserFirstName(session.user.user_metadata.first_name);
        }
      }
    });

    // Écouter les changements d'authentification
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user || null);
      if (session?.user?.user_metadata?.first_name) {
        setUserFirstName(session.user.user_metadata.first_name);
      }
    });

    return () => subscription.unsubscribe();
  }, []);

  const handleClick = () => {
    if (user) {
      // Si connecté, redirection vers le profil
      navigate("/profil");
    } else {
      // Si déconnecté, redirection vers la page de connexion
      navigate("/Connexion");
    }
  };

  const handleSignOut = async () => {
    try {
      await supabase.auth.signOut();
      setUser(null);
      setUserFirstName("");
      navigate("/");
    } catch (error) {
      console.error("Erreur lors de la déconnexion:", error);
    }
  };

  return (
    <nav className="navbar  bg-blue-600 text-white px-4 py-3 flex justify-between items-center relative">
      {/* Logo */}
      <div className="text-xl font-bold">
        <a href="/">
          <img
            src={Logo}
            alt="logo"
            style={{ width: "80px", height: "auto", marginLeft: "2rem" }}
          />
        </a>
      </div>

      {/* Menu Burger - visible uniquement sur mobile */}
      <div className="md:hidden">
        <button onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
        </button>
      </div>

      {/* Liens Navigation */}
      <div
        className={`reponsive-nav linknav md:flex md:space-x-6 md:static absolute top-16 left-0 w-full md:w-auto 
          bg-white md:bg-transparent transition-all duration-300 ease-in-out 
          ${menuOpen ? "block" : "hidden"} z-40`}
      >
        <ul className="flex flex-col md:flex-row md:items-center gap-4 md:gap-6 px-4 md:px-0">
          <li>
            <NavLink
              to="/"
              onClick={() => setMenuOpen(false)}
              className={({ isActive }) =>
                `relative inline-block px-2 py-1 transition-colors duration-300 ${
                  isActive
                    ? "text-black-500 font-bold"
                    : "text-black-600 hover:text-green-500"
                } 
            after:content-[''] after:absolute after:left-1.5 after:bottom-0 after:h-[2px] after:bg-green-500 after:w-full after:scale-x-0 after:origin-left after:transition-transform after:duration-500 
            ${
              isActive
                ? "after:scale-x-[0.85] after:left-0"
                : "hover:after:scale-x-[0.80]"
            }`
              }
            >
              Accueil
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/propriete"
              onClick={() => setMenuOpen(false)}
              className={({ isActive }) =>
                `relative inline-block px-2 py-1 transition-colors duration-300 ${
                  isActive
                    ? "text-black-500 font-bold"
                    : "text-black-600 hover:text-green-500"
                } 
            after:content-[''] after:absolute after:left-1.5 after:bottom-0 after:h-[2px] after:bg-green-500 after:w-full after:scale-x-0 after:origin-left after:transition-transform after:duration-500 
            ${
              isActive
                ? "after:scale-x-[0.85] after:left-0"
                : "hover:after:scale-x-[0.80]"
            }`
              }
            >
              Vérifier Avant
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/declarer"
              onClick={() => setMenuOpen(false)}
              className={({ isActive }) =>
                `relative inline-block px-2 py-1 transition-colors duration-300 ${
                  isActive
                    ? "text-black-500 font-bold"
                    : "text-black-600 hover:text-green-500"
                } 
            after:content-[''] after:absolute after:left-1.5 after:bottom-0 after:h-[2px] after:bg-green-500 after:w-full after:scale-x-0 after:origin-left after:transition-transform after:duration-500 
            ${
              isActive
                ? "after:scale-x-[0.80] after:left-0"
                : "hover:after:scale-x-[0.80]"
            }`
              }
            >
              Acheter
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/Apropos"
              onClick={() => setMenuOpen(false)}
              className={({ isActive }) =>
                `relative inline-block px-2 py-1 transition-colors duration-300 ${
                  isActive
                    ? "text-black-500 font-bold"
                    : "text-black-600 hover:text-green-500"
                } 
            after:content-[''] after:absolute after:left-1.5 after:bottom-0 after:h-[2px] after:bg-green-500 after:w-full after:scale-x-0 after:origin-left after:transition-transform after:duration-500 
            ${
              isActive
                ? "after:scale-x-[0.85] after:left-0"
                : "hover:after:scale-x-[0.80]"
            }`
              }
            >
              À propos
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/contact"
              onClick={() => setMenuOpen(false)}
              className={({ isActive }) =>
                `relative inline-block px-2 py-1 transition-colors duration-300 ${
                  isActive
                    ? "text-black-500 font-bold"
                    : "text-black-600 hover:text-green-500"
                } 
            after:content-[''] after:absolute after:left-1.5 after:bottom-0 after:h-[2px] after:bg-green-500 after:w-full after:scale-x-0 after:origin-left after:transition-transform after:duration-500 
            ${
              isActive
                ? "after:scale-x-[0.85] after:left-0"
                : "hover:after:scale-x-[0.80]"
            }`
              }
            >
              Contact
            </NavLink>
          </li>
        </ul>
        {/* Partie compte et bouton télécharger visible uniquement sur mobile */}
        <div className="reponsive-tele md:hidden flex flex-col items-start space-y-4 px-4 mt-4 border-t border-white/30 pt-4">
          <div className="usercompte relative">
            <button
              className="flex items-center space-x-2"
              onClick={() => {
                handleClick();
                setMenuOpen(false); // ferme le menu
              }}
            >
              <div className="userIcon">
                <UserIcon className="usericon-l h-6 w-6 text-gray-200" />
              </div>
              <p className="usercompte-text font-bold">
                {user ? `${userFirstName}` : "Se Connecter"}
              </p>
            </button>
          </div>

          <div className="usercompte">
            <button
              className="flex items-center space-x-2 px-4 py-2 bg-green-0 hover:bg-green-700 hover:text-white rounded-[10px] shadow-lg transition-all duration-300"
              style={{ border: "1px solid rgba(255, 255, 255, 0.75)" }}
              onClick={() => {
                setIsOpen(true); // ton popup existant
                setMenuOpen(false); // ferme le menu
              }}
            >
              <FaDownload />
              <p>Télécharger l'App</p>
            </button>
          </div>
        </div>
      </div>

      {/* Partie droite (compte + bouton télécharger) */}
      <div className="header-compte hidden md:flex space-x-4">
        <div className="usercompte relative ">
          <button className="flex items-center space-x-2" onClick={handleClick}>
            <div className="userIcon">
              <UserIcon className="usericon-l h-6 w-6 text-gray-500" />
            </div>
            <p className="usercompte-text" style={{ fontWeight: "bold" }}>
              {user ? `${userFirstName}` : "Se Connecter"}
            </p>
          </button>
        </div>

        <div className="usercompte">
          <button
            className="flex items-center space-x-2 px-4 py-2 bg-green-0 hover:bg-green-700 hover:text-white rounded-[10px] shadow-lg transition-all duration-300"
            style={{ border: "1px solid rgba(0, 0, 0, 0.75)" }}
            onClick={() => setIsOpen(true)}
          >
            <FaDownload />
            <p>Télecharger l'App</p>
          </button>

          {/* Overlay */}
          {isOpen && (
            <div
              className="fixed inset-0 flex items-center justify-center bg-black/60 z-50"
              style={{
                backdropFilter: "blur(5px)",
                animationDuration: "0.5s",
                animationName: "fadeIn",
              }}
            >
              {/* Popup container */}
              <div
                className="bg-white rounded-2xl shadow-2xl w-11/12 max-w-md p-6 relative text-center
  transform transition-all duration-300 ease-out animate-popup"
              >
                {/* Bouton fermer */}
                <button
                  onClick={() => setIsOpen(false)}
                  className="absolute top-3 right-3 text-gray-600 hover:text-black text-2xl"
                >
                  &times;
                </button>

                {/* QR code image */}

                <div className="flex justify-center mb-4">
                  <img src={CodeQR} alt="QR Code" className="w-32 h-32" />
                </div>

                {/* Titre */}
                <h2 className="text-xl font-bold text-gray-900 mb-2">
                  Télecharger l'App Anyigbã nya
                </h2>
                <p className="text-gray-600 mb-4">
                  Pour avoir ton terrain en toute sécurité.
                </p>

                {/* Boutons Google Play et App Store */}
                <div className=" flex justify-center items-center gap-8">
                  <a
                    href=""
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex justify-center items-center absolute"
                    style={{
                      top: "12%",
                      left: "12%",
                      transform: "translate(-50%, -50%)",
                    }}
                  >
                    <img
                      src={PlayButton} // mets l’icône App Store dans /public
                      alt="Demo"
                      className="h-12"
                      // style={{
                      //   objectFit: "contain",
                      //   maxWidth: "80%",
                      //   maxHeight: "80%",
                      // }}
                    />
                    <span>Demo</span>
                  </a>

                  <a
                    href="https://play.google.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={PlayStore} // l’icône Google Play dans
                      alt="Google Play"
                      className="h-12"
                      // style={{
                      //   objectFit: "contain",
                      //   maxWidth: "80%",
                      //   maxHeight: "80%",
                      // }}
                    />
                  </a>
                  <a
                    href="https://apps.apple.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={AppStore} //l’icône App Store dans
                      alt="App Store"
                      className="h-12"
                      // style={{
                      //   objectFit: "contain",
                      //   maxWidth: "80%",
                      //   maxHeight: "80%",
                      // }}
                    />
                  </a>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}
